import { collection, CollectionReference } from "firebase/firestore";
import { db } from "~/integrations/firebase/firestore";
import {
  FirestoreGenerationRequestDescriptions,
  FirestoreGenerationStatus as GenerationStatus,
} from "reedy-data/models";
import { converter } from "~/integrations/firebase/utils";

export { GenerationStatus };

export const getGenerationRequestsDescriptionsCollection = () =>
  collection(db, "generationRequestsDescriptions").withConverter(
    converter,
  ) as CollectionReference<FirestoreGenerationRequestDescriptions>;
